import { useContext } from 'react';
import type { RedcatPaymentStore } from '../RedcatPaymentProvider';
import { RedcatPaymentContext } from '../RedcatPaymentProvider';

export const useRedcatPayment = (): RedcatPaymentStore => {
  const ctx = useContext(RedcatPaymentContext);
  if (!ctx) {
    throw new Error('useRedcatPayment() needs to be called within RedcatPaymentProvider wrapper');
  }
  return ctx;
};
